<template>
    <div>
        <div>
            <div class="col-md-12 mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <el-row :gutter="10" class="filter-section mt-3">
                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" >
                            <el-select v-if="[7,6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)" @change="getCenter()" v-model="form.area_id" placeholder="Chọn Khu vực" filterable  collapse-tags clearable class="w-100 mt-2">
                                <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="[5,6,7].includes(keyAccount) || [295391, 266029].includes(currentUser.id) || currentUser.profile.account_type_id === 18">
                            <el-select @change="getChildUser(); form.sale= null" v-model="form.branch_id" placeholder="Chọn văn phòng" filterable clearable class="w-100 mt-2">
                                <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <tree-select v-model="form.sale" :normalizer=normalizer
                                         :options="options"
                                         :show-count="true" class="w-100 mt-2"
                                         placeholder="Chọn nhân sự muốn xem..."
                                         search-nested
                                         >
                                <!--eslint-disable-->
                                <label slot="option-label"
                                       slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                       :class="labelClassName">
                                    <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                                    <span> {{ node.label }} -  {{node.raw.id + 100000}}</span>
                                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                </label>
                            </tree-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <el-date-picker
                                v-model="deadline"
                                type="datetime"
                                class="w-100 mt-2"
                                size="large"
                                placeholder="Chọn deadline"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </el-col>
                    </el-row>
                </div>

            </div>

            <div class="col-md-12 mb-3 mt-5">
                <div class="form-group mb-1">
                    <el-input
                        type="textarea"
                        placeholder="Nhập nội dung công việc cần giao..."
                        v-model="task_content"
                        :rows="8"
                        class="task-textarea"
                    ></el-input>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer d-flex justify-content-end mr-2 mt-5">
            <el-button
                style="color: #FFFFFF; width: 80px"
                size="mini"
                :style="isDisabled ? 'background-color: rgb(125 105 189)' : 'background-color: #472F92'"
                :disabled="isDisabled || loading"
                @click="CreateTask"
            > <i v-if="loading" class="el-icon-loading"></i> Lưu</el-button>
            <el-button size="mini" style="width: 80px" @click="$emit('closeDialog')">Hủy</el-button>
        </span>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CREATE_TASK_WITH_CUSTOMER, GET_REGIONS_BY_USER} from "../../../../core/services/store/customer/customer.module";
import moment from "moment-timezone";
import {BRANCH_LIST, GET_CHILD_USER} from "../../../../core/services/store/service.module";

export default {
    name: 'createTaskDialog',
    props: {
        is_show: { type: Boolean, default: () => false },
    },
    data () {
        return {
            publicPath: process.env.VUE_APP_BASE_URL,
            form: {
                branch_id: '',
                area_id: '',
                goal_type: '',
                sale: null,
            },
            branches: [], areas: [], options: [], childUsers: [],
            task_content: '',
            deadline: '',
            loading: false,
            pickerOptions: {
                disabledDate(time) {
                    const now = new Date();
                    const selectedDate = new Date(time);
                    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                    return selectedDate < startOfToday;
                }
            },
            imageHierarchy: {
                '5': 'media/hierarchy/gdvp.png',
                '1': 'media/hierarchy/sl.png',
                '2': 'media/hierarchy/se.png',
                '3': 'media/hierarchy/s.png',
                '4': 'media/hierarchy/si.png'
            },
            cache_sale: null,
        }
    },
    watch: {
        is_show: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.clearData();
                }else {
                    this.getCenter();
                    this.getRegions();
                    this.getChildUser();
                }
            },
        },
    },

    computed: {
        ...mapGetters(["currentUser", "keyAccount"]),

        isDisabled() {
            return !(this.task_content.trim() && this.deadline );
        }
    },
    methods: {
        CreateTask() {
            this.loading = true;
            if (this.isDisabled) return;

            const contentHtml = this.task_content
                ? this.task_content.replace(/\n/g, '<br>')
                : '';
            const payload = {
                content: contentHtml,
                deadline: moment(this.deadline).format('YYYY-MM-DD HH:mm:ss'),
                sale: this.form.sale ?? this.currentUser.id,
                type: 2
            };

            // type là task việc tự tạo cô bản thân
            if(payload.sale === this.currentUser.id) payload.type = 3;

            console.log('payload', payload)
            this.$store.dispatch(CREATE_TASK_WITH_CUSTOMER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({ type: 'warning', message: `${response.message}`, showClose: true });
                        this.loading = false;
                    } else {
                        this.close();
                        this.$message({ type: 'success', message: 'Tạo task thành công!', showClose: true });
                        this.loading = false;
                    }
                });
        },

        getChildUser() {
            var branchId = '';
            if([1,5].includes(this.currentUser.account_type.id)){
                branchId = this.currentUser.profile.chi_nhanh_id;
            };
            const payload = {
                branch_id: this.form.branch_id || branchId,
            };
            this.$store.dispatch(GET_CHILD_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.childUsers = response.data;
                        this.options = response.data;
                    }
                });
        },

        getCenter() {
            const payload = {
                area_id: this.form.area_id
            };

            this.$store.dispatch(BRANCH_LIST,payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                })

        },

        getRegions() {
            const payload = {
                all: this.keyAccount === 7 ? 1 : 0
            };
            this.$store.dispatch(GET_REGIONS_BY_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.areas = response.data;
                    }
                })
        },

        normalizer: function (node) {
            return {
                id: node.id,
                label: node.name,
            }
        },

        getImageHierarchy(account_type) {
            return this.imageHierarchy[account_type];
        },

        clearData() {
            this.task_content = '';
            this.deadline = '';
        },

        close() {
            this.$emit('close');
        }
    }
}
</script>
